<template>
  <div v-if="stock_order_details && formater">
    <v-sheet class="hidden-print" style="margin-top: 80px" />
    <OnePiecePrint :formater="formater" :data="stock_order_details" />
  </div>
</template>
<script>
import StockOuts from "@/api/stock_outs";
import PrintTemplates from "@/api/print_templates";
import OnePiecePrint from "@/components/plugins/print/OnePiecePrint";

export default {
  components: {
    OnePiecePrint,
  },

  data: () => ({
    formater: null,
    stock_order_details: {},
  }),

  mounted() {
    let templateName = this.$route.query.fromType == "material"
        ? "waitOutMaterialCountByMaterial"
        : "waitOutMaterialCountByShop"
    PrintTemplates.fetchOne(templateName).then(
      function (response) {
        if (response.data.status.isOK()) {
          // console.log(response);
          var formater = response.data.print_template.template;
          this.formater = formater;
          //获取单据详情
          delete this.$route.query.fromType;
          this.$route.query.templateName = templateName;
          StockOuts.waitOutMaterialAnalyses(this.$route.query).then(
            function (response) {
              if (response.data.status.isOK()) {
                var total_default_confirm_num = 0;
                var total_confirm_num = 0;
                var total_shop_count = 0;

                var stock_order_details = response.data.stock_order_details.map(
                  (detail) => {
                    detail.default_confirm_num =
                      this.$numberFormatter.formatTwoDot(
                        detail.default_confirm_num
                      );
                    total_default_confirm_num += detail.default_confirm_num;
                    total_confirm_num += detail.confirm_num;
                    total_shop_count += detail.shop_count;
                    return detail;
                  }
                );
                // console.log(response.data.stock_order_details);
                var stock = response.data.stock ? response.data.stock : null;

                this.stock_order_details = Object.assign(
                  {},
                  {
                    stock_order_details: stock_order_details,
                    stock: stock,
                    total_default_confirm_num: total_default_confirm_num,
                    total_confirm_num: total_confirm_num,
                    total_shop_count: total_shop_count,
                  }
                );
              }
            }.bind(this)
          );
        }
      }.bind(this)
    );
  },
};
</script>